export const upgradesData = {
  axes: {
    woodCost: 20,
    stoneCost: 20,
    metalCost: 0,
  },
  pickaxes: {
    woodCost: 20,
    stoneCost: 0,
    metalCost: 20,
  },
  surveying: {
    woodCost: 0,
    stoneCost: 20,
    metalCost: 20,
  },
};
